import { api } from '../index';

const prefix = '/api/item/item_master/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectItemList(param) {
	return api.post(prefix + 'selectItemList', param);
}

export function apiSelectItem(param) {
	return api.post(prefix + 'selectItem', param);
}

export function apiCheckItemExists(param) {
	return api.post(prefix + 'checkItemExists', param);
}

export function apiInsertItem(param) {
	param.mode = 'insert';
	return apiSubmitItem(param);
}

export function apiUpdateItem(param) {
	param.mode = 'update';
	return apiSubmitItem(param);
}

export function apiDeleteItem(param) {
	param.mode = 'delete';
	return apiSubmitItem(param);
}

function apiSubmitItem(param) {
	return api.post(prefix + 'submitItem', param);
}
export function apiSelectItemByBarcode(barcode) {
	return api.get(prefix + 'label/' + barcode);
}

export function apiBatchSubmit(param) {
	return api.post(prefix + 'batchSubmit', param);
}

export function apiUpdateCostBatch(param) {
	return api.post(prefix + 'updateCostBatch', param);
}

export function apiResetBackOrderCountBatch(param) {
	return api.post(prefix + 'resetBackOrderCountBatch', param);
}

export function apiInsertPicture(param) {
	return api.post(prefix + 'insertPicture', param);
}

export function apiDeletePicture(param) {
	return api.post(prefix + 'deletePicture', param);
}

export function apiLoadFromExcel(param) {
	return api.post(prefix + 'loadFromExcel', param);
}

export function apiInventoryStatus(param) {
	return api.get(prefix + 'inventoryStatus/data' + param);
}

export function apiInventoryStatusRawData(param) {
	return api.get(prefix + 'inventoryStatus/rawData' + param);
}

export function apiSelectUpcInventoryItems(param) {
	return api.post(prefix + 'upc-inventory-item', param);
}

export function apiGetNewBarcode() {
	return api.get(prefix + 'getNewBarcode');
}
